import React from 'react';
import { ProductTransactionStatus } from '../types/order/productTransactionStatus';

export interface ProductTransactionStatusContextProps {
  productTransactionStatuses: Map<string, ProductTransactionStatus>;
  setProductTransactionStatuses: (productTransactionStatuses: Map<string, ProductTransactionStatus>) => void;
  productTransactionStatusesLoading: boolean;
}

const defaultContext: ProductTransactionStatusContextProps = {
  productTransactionStatuses: new Map(),
  setProductTransactionStatuses: () => {},
  productTransactionStatusesLoading: false,
};

export const ProductTransactionStatusContext =
  React.createContext<ProductTransactionStatusContextProps>(defaultContext);
